<template>
  <div>
    <form novalidate @submit.prevent="handleFormSubmit">
      <div class="row">
        <div class="col">
          <div class="card card-modern">
            <!--<div class="card-header">
                    <h2 class="card-title">Zaglavlje</h2>
                </div>-->
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <div class="form-group">
                    <label class="control-label">Prostor</label>
                    <!--Glavna kategorija (npr Kuhinja, jedan plan za jednu lokaciju = glavnu kategoriju = prostor)-->
                    <div>
                      <treeselect
                        v-model="parentCleaningAreaId"
                        :options="parentAreas"
                        placeholder="Izaberite prostor"
                        @select="getChildAreas"
                      />
                    </div>
                  </div>
                </div>
                <!--/col-md-4-->

                <div class="col-lg-5 col-md-4">
                  <div class="form-group">
                    <label class="control-label">Komitent</label>
                    <treeselect
                      v-model="companyId"
                      :options="companies"
                      placeholder="Izaberite komitenta"
                    />
                  </div>
                </div>
                <!--/col-md-4-->

                <div class="col-lg-3 col-md-4">
                  <div class="form-group row">
                    <label class="control-label">Datum plana</label>
                    <datepicker
                      input-class="form-control form-control-modern bg-body"
                      :monday-first="true"
                      :full-month-name="true"
                      :language="bs"
                      :format="customFormatter"
                      v-model="cleaningPlanDate"
                      :disabled-dates="disabledDates"
                    ></datepicker>
                  </div>
                </div>
                <!--/col-md-4-->
              </div>
              <!--/row-->
            </div>
            <!--/card body-->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="card card-modern">
            <div class="card-header">
              <div class="row align-items-center mb-5">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <div class="btn-group flex-wrap">
                    <button
                      class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 me-2"
                      data-bs-target="#add-item-modal"
                      type="button"
                      data-bs-toggle="modal"
                      :disabled="!parentCleaningAreaId|| !companyId"
                    >
                      + Dodaj stavku
                    </button>
                  </div>

                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#remove-items-modal"
                    class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4"
                    :disabled="!selectedItems.length"
                  >
                    - Ukloni stavku
                  </button>
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  ></div>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="cleaningPlanItems.length">
              <div class="datatables-header-footer-wrapper">
                <table
                  class="table table-offer table-ecommerce-simple table-borderless table-striped"
                >
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th>RBR</th>
                      <th>Područje primjene</th>
                      <th>Sredstvo</th>
                      <th>Oprema</th>
                      <th>Odgovorna osoba</th>
                      <th>Akcija</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in cleaningPlanItems" :key="item.uniqueId">
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="item.uniqueId"
                          v-model="selectedItems"
                        />
                      </td>
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.cleaningAreaTitle }}</td>
                      <td>
                        <a href="#"
                          ><strong
                            >{{ item.cleaningProductTitle }}</strong
                          ></a
                        >
                      </td>
                      <td>
                        <a href="#"
                          ><strong>{{ item.helpingEquipmentTitle }}</strong></a
                        >
                      </td>
                      <td>{{ item.responsiblePerson }}</td>
                      <td>
                        <a href="#"> <i class="bx bxs-edit"></i></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr class="solid mt-5 opacity-4" />
                <div class="datatable-footer">
                  <div
                    class="row align-items-center justify-content-between mt-3"
                  >
                    <div class="col-md-auto order-1 mb-3 mb-lg-0"></div>
                    <div class="col-lg-auto text-center order-3 order-lg-2">
                      <div class="results-info-wrapper"></div>
                    </div>
                    <div class="col-lg-auto order-2 order-lg-3 mb-3 mb-lg-0">
                      <div class="pagination-wrapper"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" style="margin-top: 30px">
          <div class="card card-modern">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <label class="control-label">Logo (Footer)</label>
                  <div
                    class="fileupload fileupload-new"
                    data-provides="fileupload"
                  >
                    <input
                      type="file"
                      class="form-control form-control-modern"
                      ref="logoFooter"
                      accept="image/*"
                      @change="handlePhotoUpload"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <label class="control-label">Info text (Footer)</label>
                  <textarea
                    class="form-control form-control-modern"
                    rows="1"
                    v-model="infoFooterText"
                  ></textarea>
                </div>
              </div>
              <!--/row-->
            </div>
            <!--/card body-->
          </div>
        </div>

        <div class="action-buttons" style="margin-top: 2rem">
          <div
            class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
          >
            <router-link
              :to="{ name: 'CleaningPlans' }"
              exact
              class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            >
              Otkaži
            </router-link>
            <button
              type="submit"
              class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            >
              <i class="bx bx-save text-4 me-2"></i>Sačuvaj
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- Add item modal -->
    <modal id="add-item-modal" css-class="modal-xl">
      <div slot="header">
        <h2 class="card-title">Dodavanje stavke plana</h2>
      </div>
      <div slot="body">
        <div>
          <div>
            <div
              class="form-group row mb-2"
              :class="{ 'has-danger': $v.applianceAreaId.$anyError }"
            >
              <label class="col-lg-3 control-label text-lg-end pt-2">
                Područje primjene
              </label>
              <!--Podkategorija od Prostora (npr, glavna kategorija tj prostor je kuhinja, a pećnica je podkategorija)-->
              <div class="col-lg-9">
                <div :class="{ has__error: $v.applianceAreaId.$anyError }">
                  <treeselect
                    v-model="applianceAreaId"
                    :options="childAreas"
                    placeholder="Izaberite prostor"
                  />
                </div>
                <form-error
                  :model="$v.applianceAreaId"
                  label="Područje primjene"
                  :dirty="$v.$dirty"
                />
              </div>
            </div>

            <div
              class="form-group row mb-2"
              :class="{ 'has-danger': $v.cleaningProductId.$anyError }"
            >
              <label class="col-lg-3 control-label text-lg-end pt-2">
                Sredstvo za čišćenje
              </label>
              <div class="col-lg-9">
                <div :class="{ has__error: $v.cleaningProductId.$anyError }">
                  <treeselect
                    v-model="cleaningProductId"
                    loadingText="Učitavanje..."
                    noResultsText="Nema rezultata"
                    searchPromptText="Unesite naziv rtikla"
                    :load-options="loadArticles"
                    :async="true"
                    :options="articles"
                    placeholder="Izaberite artikal"
                    @select="setCleaningProductTitle"
                  />
                </div>

                <form-error
                  :model="$v.cleaningProductId"
                  label="Sredstvo za čišćenje"
                  :dirty="$v.$dirty"
                />
              </div>
            </div>

            <div class="form-group row mb-2">
              <label class="col-lg-3 control-label text-lg-end pt-2">
                Oprema (Pomagalo)
              </label>
              <div class="col-lg-9">
                <treeselect
                  v-model="helpingEquipmentId"
                  loadingText="Učitavanje..."
                  noResultsText="Nema rezultata"
                  searchPromptText="Unesite naziv rtikla"
                  :load-options="loadArticles"
                  :async="true"
                  :options="articles"
                  placeholder="Izaberite artikal"
                  @select="setHelpingEquipmentTitle"
                />
              </div>
            </div>

            <div
              class="form-group row mb-2"
              :class="{ 'has-danger': $v.howToUseItem.$anyError }"
            >
              <label class="col-lg-3 control-label text-lg-end pt-2">
                Kako koristiti
              </label>
              <!--PAŽNJA! Vuče tekst iz onog taba na artiklu gdje smo rekli da je povazano sa planom za čišćenje-->
              <div class="col-lg-9">
                <editor
                  name="html-editor"
                  :init="{
                    ...appSettings.tinyMceConfig
                  }"
                  v-model="howToUseItem"
                  class="form-control"
                ></editor>

                <div :class="{'has__error-inline': howToUseItem.length > 1000}">
                  {{ howToUseItem.length }} / 1000
                </div>

                <form-error
                  :model="$v.howToUseItem"
                  label="Kako koristiti"
                  :dirty="$v.$dirty"
                />
                
              </div>
            </div>

            <div class="form-group row mb-2">
              <label class="col-lg-3 control-label text-lg-end pt-2">
                Kada koristiti
              </label>
              <div class="col-lg-9">
                <textarea
                  class="form-control"
                  v-model="whenToUseItem"
                  rows="6"
                ></textarea>
              </div>
            </div>

            <hr />

            <div class="form-group row mb-2">
              <label class="col-lg-3 control-label text-lg-end pt-2"
                >Napomena</label
              >
              <div class="col-lg-9">
                <textarea
                  class="form-control"
                  v-model="note"
                  rows="6"
                ></textarea>
              </div>
            </div>

            <div class="form-group row mb-2">
              <label class="col-lg-3 control-label text-lg-end pt-2"
                >Izaberi ikone</label
              >
              <!--Izaberi ikone iz biblioteke - maksimalno će 4 ikone biti prikazane-->
              <div class="col-lg-9">
                <treeselect
                  :options="icons"
                  :multiple="true"
                  v-model="cleaningPlanNoteIconsIds"
                  placeholder="Izaberi ikone"
                />
              </div>
            </div>

            <hr />

            <div
              class="form-group row mb-2"
              :class="{ 'has-danger': $v.responsiblePerson.$anyError }"
            >
              <label class="col-lg-3 control-label text-lg-end pt-2"
                >Odgovorna osoba</label
              >
              <div class="col-lg-9">
                <input
                  class="form-control"
                  type="text"
                  v-model="responsiblePerson"
                />

                <form-error
                  :model="$v.responsiblePerson"
                  label="Odgovorna osoba"
                  :dirty="$v.$dirty"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss me-2"
              @click="closeModal"
            >Odustani</button>
            <button class="btn btn-primary modal-confirm" @click="addItemToList">Dodaj</button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="remove-items-modal">
      <div slot="header">Upozorenje?</div>
      <div slot="body">
        <div>
          <div class="modal-icon">
            <i class="fas fa-question-circle"></i>
          </div>
          <div class="modal-text">
            <h4 class="font-weight-bold text-dark">Pažnja!</h4>
            <p>Jeste li sigurni da želite ukloniti odabrane stavke?</p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button class="btn btn-default modal-dismiss me-2" @click="closeDeleteModal">Odustani</button>
            <button
              class="btn btn-primary modal-confirm"
              @click="removeSelectedItems"
            >Ukloni</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { format } from 'date-fns';
import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';
import config from '@/config';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import editor from "@tinymce/tinymce-vue";

import Modal from '@/components/shared/modal/Modal.vue';
import api from '@/services/api';
import { translations } from '@/mixins';

import validations from './validation-schema/add.js';
import FormError from '@/components/shared/form-errors/FormError.vue';

export default {
  name: 'AddCleaningPlan',
  mixins: [translations],
  components: {
    Datepicker,
    Treeselect,
    Modal,
    FormError,
    editor
  },
  validations,
  data() {
    return {
      parentCleaningAreaId: null,
      cleaningAreaTitle: null,
      applianceAreaId: null,
      childCleaningAreaTitle: null,
      companyId: null,
      cleaningPlanDate: new Date(),
      cleaningProductId: null,
      cleaningProductTitle: null,
      helpingEquipmentId: null,
      helpingEquipmentTitle: null,
      howToUseItem: '',
      whenToUseItem: null,
      note: null,
      responsiblePerson: null,
      cleaningPlanNoteIconsIds: [],
      cleaningPlanItems: [],
      logoUrl: null,
      infoFooterText: null,
      // This will represent selected cleaning plan items
      selectedItems: [],
      articles: [],
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    companies() {
      return this.$store.getters.getCompanies.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    parentAreas() {
      return this.$store.getters.getParentCleaningAreas.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    childAreas() {
      return this.$store.getters.getCleaningAreas.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    icons() {
      return this.$store.getters.getCleaningPlanNoteIcons.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
    bs() {
      return bs;
    },
    selectAll: {
      get: function () {
        // List must be defined in upper component
        return this.selectedItems.length == this.cleaningPlanItems.length;
      },
      set: function (value) {
        const selected = [];

        if (value) {
          this.cleaningPlanItems.forEach(function (item) {
            selected.push(item.uniqueId);
          });
        }

        this.selectedItems = selected;
      }
    },
    appSettings() {
      return config.appSettings;
    },
  },
  methods: {
    formatDate(date, dateFormat = 'dd.MM.yyyy, HH:mm') {
      return format(new Date(date), dateFormat);
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    getChildAreas(area) {
      this.cleaningAreaTitle = area.label;
      this.applianceAreaId = null;
      this.$store.dispatch('getCleaningAreas', {
        retrieveAll: true,
        sortBy: 'title',
        isSortAscending: true,
        filterByParentId: area.id
      });
    },
    loadArticles({ callback, searchQuery }) {
      if (searchQuery.length >= 3) {
        api.getCleaningPlanArticles({
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: "title",
        })
        .then((response) => {
          this.articles = response.data.data.map((item) => {
            return {
              id: item.id,
              label: item.title,
              howToUseItem: item.howToUse,
            };
          });
          this.howToUseItem 
          callback(null, this.articles);
        });
      }
    },
    addItemToList() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const {
        cleaningProductId,
        helpingEquipmentId,
        cleaningAreaTitle,
        howToUseItem,
        whenToUseItem,
        note,
        responsiblePerson,
        cleaningPlanNoteIconsIds,
        cleaningProductTitle,
        helpingEquipmentTitle,
        applianceAreaId,
      } = this;

      this.cleaningPlanItems.push({
        cleaningProductId,
        applianceAreaId,
        helpingEquipmentId,
        cleaningAreaTitle,
        howToUseItem,
        whenToUseItem,
        note,
        responsiblePerson,
        cleaningPlanNoteIconsIds,
        cleaningProductTitle,
        helpingEquipmentTitle,
        uniqueId: new Date().valueOf(),
      });

      $('#add-item-modal').modal('hide');
    },
    setCleaningProductTitle(product) {
      this.cleaningProductTitle = product.label;
      this.howToUseItem = product.howToUseItem;
    },
    setHelpingEquipmentTitle(product) {
      this.helpingEquipmentTitle = product.label;
    },
    handlePhotoUpload() {
      const file = this.$refs.logoFooter.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.logoUrl = e.target.result.split(',')[1];
      };
    },
    handleFormSubmit() {
      const payload = {
        cleaningPlanItems: this.cleaningPlanItems,
        companyId: this.companyId,
        parentCleaningAreaId: this.parentCleaningAreaId,
        cleaningPlanDate: this.cleaningPlanDate,
        logoUrl: this.logoUrl,
        infoFooterText: this.infoFooterText,
      };

      api.createCleaningPlan(payload).then((response) => {
        this.$toast.info(response.data.info);
        if (response.data.isValid && response.data.data != null && response.data.data != undefined) {
          this.$router.push({ name: 'EditAddCleaningPlan', params: { id: response.data.data } });
        }
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    closeModal() {
      $('#add-item-modal').modal('hide');
    },
    closeDeleteModal() {
      $('#remove-items-modal').modal('hide');
    },
    removeSelectedItems() {
      this.cleaningPlanItems = this.cleaningPlanItems.filter((item) => {
        return this.selectedItems.indexOf(item.uniqueId) === -1
      });
      this.selectedItems = [];
      this.closeDeleteModal();
    },
  },
  mounted() {
    this.$store.dispatch('getCompanies', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getParentCleaningAreas');
    this.$store.dispatch('getCleaningPlanNoteIcons', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
};
</script>
<style lang="scss">
.vue-treeselect {
  min-height: 47px;
  line-height: 47px;
}

.vue-treeselect__control {
  min-height: 47px;
  line-height: 47px;
}

.vue-treeselect__value-container {
  min-height: 47px;
  line-height: 47px;
}

.has__error {
  border: 1px solid #d2322d;
  border-radius: 5px;

  &-inline {
    border: none;
    color: #d2322d;
  }
}
</style>